import { useSearchParams } from 'react-router';
export function useListParams() {
  const [params, setParams] = useSearchParams();
  const update = (values: Record<string, string>, resetPage = true) => setParams(current => {
    const next = new URLSearchParams(current);
    if (resetPage) next.delete('page');
    Object.entries(values).forEach(([key, value]) => value ? next.set(key, value) : next.delete(key));
    return next;
  });
  return { params, update };
}
export function pageOf<T>(items: T[], raw: string | null, size = 8) {
  const parsed = Number(raw); const page = Math.max(1, Math.min(Math.ceil(items.length / size) || 1, Number.isFinite(parsed) ? Math.floor(parsed) || 1 : 1));
  return { page, items: items.slice((page - 1) * size, page * size) };
}
